import { Controller } from "@hotwired/stimulus"

// Habilita el botón "Confirmar" solo cuando se selecciona una modalidad.
// Replica: ActivityRSVPCommunityBtn disabled={!modality} cuando hybrid && !rsvp.
export default class extends Controller {
  static targets = ["radio", "submitBtn"]

  select() {
    const anyChecked = this.radioTargets.some(r => r.checked)
    if (this.hasSubmitBtnTarget) {
      this.#setDisabled(this.submitBtnTarget, !anyChecked)
    }
  }

  // Sincroniza atributo `disabled` + las clases que agrega `btn_to disabled: true`
  // (pointer-events-none, cursor-not-allowed, opacity-50). Sin esto, las clases
  // del render inicial sobreviven al cambio del atributo y bloquean el click.
  #setDisabled(el, disabled) {
    el.disabled = disabled
    el.classList.toggle("pointer-events-none", disabled)
    el.classList.toggle("cursor-not-allowed", disabled)
    el.classList.toggle("opacity-50", disabled)
  }
}
